import React from "react";
import { TableRow } from "@mui/material";

import {
  PERMISSION_LEVELS,
  PERMISSION_TYPES,
} from "../../constants/permissions";
import { HubHookFormSelect, HubHookFormSwitch } from "../../components";

import { PermissionRender, permissionRenderValue } from "./PermissionRender";
import { StyledPinnedColumn, StyledTableCell } from "./styles";
import { usePutRolePermissionValue } from "../../hooks";

const getPermissionName = (name) => {
  const label = name
    .split("_")
    .map((word) => {
      const lower = word.toLowerCase();
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(" ");
  return label;
};

const RolePermissionsTableSubRow = ({ permission = {}, roles = [] }) => {
  const { mutate: putRolePermissionValue } = usePutRolePermissionValue();

  const onChange = ({ roleId, permissionId, value }) => {
    putRolePermissionValue({ roleId, permissionId, value });
  };

  return (
    <TableRow key={permission?.id}>
      <StyledPinnedColumn sx={{ paddingLeft: "35px !important" }}>
        {getPermissionName(permission?.name)}
      </StyledPinnedColumn>
      {roles?.map((role) => {
        const rolePermissions = role?.permissions || [];
        const rolePermission =
          rolePermissions.find(
            ({ permissionId }) => permissionId === permission.id
          ) || {};
        const value = rolePermission?.value || 0;
        return (
          <StyledTableCell>
            {permission.type === PERMISSION_TYPES.ACCESS ? (
              <HubHookFormSelect
                name={`${role?.id}.permissions.${permission.id}`}
                options={PERMISSION_LEVELS}
                defaultValue={value}
                RenderComponent={PermissionRender}
                renderValue={permissionRenderValue}
                onChange={(e) =>
                  onChange({
                    roleId: role.id,
                    permissionId: permission.id,
                    value: e.target.value,
                  })
                }
                requried
              />
            ) : (
              <HubHookFormSwitch
                name={`${role?.id}.permissions.${permission.id}`}
                defaultValue={!!value}
                isCheckbox
                onChange={(value) =>
                  onChange({
                    roleId: role.id,
                    permissionId: permission.id,
                    value: value ? 1 : 0,
                  })
                }
              />
            )}
          </StyledTableCell>
        );
      })}
    </TableRow>
  );
};

export default RolePermissionsTableSubRow;
